module.exports = __webpack_public_path__ + "img/register_success.58a4cc92.png";